export default "__VITE_ASSET__C3pE7Rhu__"